var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAstariaLogo = function SvgAstariaLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4034 1143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "#C2A6F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "url(#astaria-logo_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "url(#astaria-logo_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "url(#astaria-logo_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "url(#astaria-logo_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "url(#astaria-logo_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "url(#astaria-logo_svg__f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "url(#astaria-logo_svg__g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Z",
    fill: "url(#astaria-logo_svg__h)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "#C2A6F1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "url(#astaria-logo_svg__i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "url(#astaria-logo_svg__j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "url(#astaria-logo_svg__k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "url(#astaria-logo_svg__l)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "url(#astaria-logo_svg__m)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "url(#astaria-logo_svg__n)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "url(#astaria-logo_svg__o)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.916.44-38.049h-41.623l.031 38.049h41.152Z",
    fill: "url(#astaria-logo_svg__p)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "#C2A6F1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__q)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__r)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__s)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__t)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__u)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__v)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__w)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.273 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__x)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "#C2A6F1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__y)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__z)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__A)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__B)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__C)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__D)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__E)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.7 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__F)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "#C2A6F1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "url(#astaria-logo_svg__G)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "url(#astaria-logo_svg__H)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "url(#astaria-logo_svg__I)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "url(#astaria-logo_svg__J)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "url(#astaria-logo_svg__K)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "url(#astaria-logo_svg__L)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "url(#astaria-logo_svg__M)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.867-.572 38.049h43.166v-38.049H812.1Z",
    fill: "url(#astaria-logo_svg__N)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "#C2A6F1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "url(#astaria-logo_svg__O)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "url(#astaria-logo_svg__P)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "url(#astaria-logo_svg__Q)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "url(#astaria-logo_svg__R)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "url(#astaria-logo_svg__S)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "url(#astaria-logo_svg__T)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "url(#astaria-logo_svg__U)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.867v38.049h37.313l-.032-38.049h-37.281Z",
    fill: "url(#astaria-logo_svg__V)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "#C2A6F1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "url(#astaria-logo_svg__W)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "url(#astaria-logo_svg__X)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "url(#astaria-logo_svg__Y)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "url(#astaria-logo_svg__Z)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "url(#astaria-logo_svg__aa)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "url(#astaria-logo_svg__ab)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "url(#astaria-logo_svg__ac)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.47 464.246V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    fill: "url(#astaria-logo_svg__ad)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "#C2A6F1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__ae)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__af)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__ag)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__ah)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__ai)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__aj)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__ak)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__al)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "#C2A6F1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "url(#astaria-logo_svg__am)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "url(#astaria-logo_svg__an)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "url(#astaria-logo_svg__ao)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "url(#astaria-logo_svg__ap)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "url(#astaria-logo_svg__aq)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "url(#astaria-logo_svg__ar)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "url(#astaria-logo_svg__as)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    fill: "url(#astaria-logo_svg__at)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "#C2A6F1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__au)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__av)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__aw)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__ax)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__ay)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__az)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__aA)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    fill: "url(#astaria-logo_svg__aB)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "#C2A6F1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "url(#astaria-logo_svg__aC)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "url(#astaria-logo_svg__aD)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "url(#astaria-logo_svg__aE)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "url(#astaria-logo_svg__aF)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "url(#astaria-logo_svg__aG)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "url(#astaria-logo_svg__aH)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "url(#astaria-logo_svg__aI)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    fill: "url(#astaria-logo_svg__aJ)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "#C2A6F1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "url(#astaria-logo_svg__aK)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "url(#astaria-logo_svg__aL)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "url(#astaria-logo_svg__aM)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "url(#astaria-logo_svg__aN)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "url(#astaria-logo_svg__aO)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "url(#astaria-logo_svg__aP)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "url(#astaria-logo_svg__aQ)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    fill: "url(#astaria-logo_svg__aR)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "#C2A6F1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "url(#astaria-logo_svg__aS)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "url(#astaria-logo_svg__aT)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "url(#astaria-logo_svg__aU)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "url(#astaria-logo_svg__aV)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "url(#astaria-logo_svg__aW)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "url(#astaria-logo_svg__aX)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "url(#astaria-logo_svg__aY)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Z",
    fill: "url(#astaria-logo_svg__aZ)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "#C2A6F1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "url(#astaria-logo_svg__ba)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "url(#astaria-logo_svg__bb)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "url(#astaria-logo_svg__bc)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "url(#astaria-logo_svg__bd)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "url(#astaria-logo_svg__be)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "url(#astaria-logo_svg__bf)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "url(#astaria-logo_svg__bg)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 343.406v-41.12h47.98v41.12h-47.98Z",
    fill: "url(#astaria-logo_svg__bh)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.916h164.067l-86.56 93.147 27.888 25.912 87.265-93.906v250.697l38.054.032V620.431l173.456 124.788 22.208-30.879-164.61-118.424H765.83l.572-38.049H653.131l140.316-147.271-26.99-26.858-141.766 148.794V287.334l-38.054-.031v245.659L463.528 393.603l-28.512 25.176 122.87 139.088h-163.47l-.439 38.049Zm-40.79 0 .44-38.049h-41.623l.031 38.049h41.152Zm441.344-241.643 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Zm54.853-57.573 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213ZM812.1 557.867l-.572 38.049h43.166v-38.049H812.1Zm88.286 0v38.049h37.313l-.032-38.049h-37.281Zm1271.084-93.621V426.63h-70.01V306.655h-39.45V426.63h-44.37v37.616h44.37v366.258h39.45V464.246h70.01Z",
    stroke: "#1A1919"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1312.94 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.53 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    stroke: "#1A1919"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.86 417.721c47.33 0 86.78 21.778 105.51 65.333l-33.53 17.818c-13.8-31.677-41.41-45.535-70.01-45.535-45.36 0-68.04 34.646-68.04 64.343 0 39.595 31.55 52.464 71 68.302 5.13 2.011 10.22 3.942 15.24 5.849l.01.003.01.003c34.5 13.104 65.9 25.025 88.28 53.538 16.77 20.788 20.71 42.565 20.71 65.333 0 92.059-69.03 128.685-131.16 128.685-67.05 0-122.28-39.595-139.04-106.908l38.46-11.878c13.8 53.454 56.21 81.17 100.58 81.17 51.28 0 89.74-36.625 89.74-89.09 0-45.534-28.6-62.362-89.74-87.11-40.43-16.828-70.01-29.696-87.76-53.453-8.88-11.879-17.75-28.707-17.75-52.464 0-61.374 46.35-103.939 107.49-103.939Z",
    stroke: "#1A1919"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2460.74 417.721c63.11 0 118.34 24.747 156.79 79.191V426.63h39.45v403.874h-39.45v-72.261c-40.43 62.362-104.52 83.15-156.79 83.15-105.52 0-196.24-80.181-196.24-212.826 0-124.726 78.89-210.846 196.24-210.846Zm158.77 207.877c0-119.777-87.77-170.261-156.8-170.261-79.87 0-156.79 60.383-156.79 170.261 0 91.069 56.21 178.179 157.78 178.179 100.58 0 155.81-85.13 155.81-178.179Z",
    stroke: "#1A1919"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M2838.06 830.504h39.44V613.719c0-50.484.99-158.382 81.85-158.382 17.75 0 25.64 4.949 29.59 7.919l19.72-35.636c-14.79-7.919-31.56-9.899-42.41-9.899-43.38 0-73.95 26.727-88.75 61.373V426.63h-39.44v403.874Z",
    stroke: "#1A1919"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3681.55 496.912c-38.46-54.444-93.68-79.191-156.79-79.191-117.35 0-196.24 86.12-196.24 210.846 0 132.645 90.72 212.826 196.24 212.826 52.26 0 116.36-20.788 156.79-83.15v72.261H3721V426.63h-39.45v70.282Zm-154.82-41.575c69.03 0 156.8 50.484 156.8 170.261 0 93.049-55.23 178.179-155.81 178.179-101.57 0-157.78-87.11-157.78-178.179 0-109.878 76.91-170.261 156.79-170.261Z",
    stroke: "#1A1919"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M3131.6 827.686V423.334h41.13v404.352h-41.13Zm0-484.28v-41.12h47.98v41.12h-47.98Z",
    stroke: "#1A1919"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "#C2A6F1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "url(#astaria-logo_svg__bi)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "url(#astaria-logo_svg__bj)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "url(#astaria-logo_svg__bk)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "url(#astaria-logo_svg__bl)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "url(#astaria-logo_svg__bm)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "url(#astaria-logo_svg__bn)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "url(#astaria-logo_svg__bo)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Z",
    fill: "url(#astaria-logo_svg__bp)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "#C2A6F1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "url(#astaria-logo_svg__bq)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "url(#astaria-logo_svg__br)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "url(#astaria-logo_svg__bs)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "url(#astaria-logo_svg__bt)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "url(#astaria-logo_svg__bu)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "url(#astaria-logo_svg__bv)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "url(#astaria-logo_svg__bw)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m353.187 595.69.44-38.048h-41.623l.031 38.048h41.152Z",
    fill: "url(#astaria-logo_svg__bx)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "#C2A6F1"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__by)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__bz)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__bA)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__bB)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__bC)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__bD)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__bE)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m794.531 354.047 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Z",
    fill: "url(#astaria-logo_svg__bF)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "#C2A6F1"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__bG)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__bH)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__bI)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__bJ)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__bK)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__bL)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__bM)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m849.384 296.475 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213Z",
    fill: "url(#astaria-logo_svg__bN)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "#C2A6F1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "url(#astaria-logo_svg__bO)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "url(#astaria-logo_svg__bP)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "url(#astaria-logo_svg__bQ)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "url(#astaria-logo_svg__bR)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "url(#astaria-logo_svg__bS)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "url(#astaria-logo_svg__bT)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "url(#astaria-logo_svg__bU)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m812.1 557.642-.572 38.048h43.166v-38.048H812.1Z",
    fill: "url(#astaria-logo_svg__bV)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "#C2A6F1"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "url(#astaria-logo_svg__bW)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "url(#astaria-logo_svg__bX)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "url(#astaria-logo_svg__bY)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "url(#astaria-logo_svg__bZ)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "url(#astaria-logo_svg__ca)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "url(#astaria-logo_svg__cb)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "url(#astaria-logo_svg__cc)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M900.386 557.642v38.048h37.313l-.032-38.048h-37.281Z",
    fill: "url(#astaria-logo_svg__cd)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M393.977 595.69h164.067l-86.56 93.148 27.888 25.911 87.265-93.906v250.698l38.054.031V620.206l173.456 124.787 22.208-30.878-164.61-118.425H765.83l.572-38.048H653.131L793.447 410.37l-26.99-26.858-141.766 148.794V287.108l-38.054-.031v245.659L463.528 393.378l-28.512 25.175 122.87 139.089h-163.47l-.439 38.048Zm-40.79 0 .44-38.048h-41.623l.031 38.048h41.152Zm441.344-241.643 26.989 26.858 26.781-28.108-26.99-26.858-26.78 28.108Zm54.853-57.572 26.99 26.858 25.548-26.815-27.563-26.256-24.975 26.213ZM812.1 557.642l-.572 38.048h43.166v-38.048H812.1Zm88.286 0v38.048h37.313l-.032-38.048h-37.281Z",
    stroke: "#1A1919"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__G",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__S",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__T",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__W",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ab",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ac",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ae",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ai",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ak",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__am",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__as",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__au",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ay",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__az",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aA",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aH",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aI",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aP",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aQ",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aX",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__aY",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ba",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(147.895 1629.187 745.926) scale(1101.69 869.761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__be",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-161.176 977.288 114.9) scale(508.73 752.192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bf",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-860.76907 -216.05054 144.40714 -575.3339 1534.98 871.798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-939.60542 -157.3709 97.31232 -581.01713 1820.48 793.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bi",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(106.306 248.187 585.503) scale(610.055 288.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bm",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-118.299 459.449 91.058) scale(186.428 376.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bn",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-157.98712 -216.04394 291.40308 -213.09523 536.472 871.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-172.45609 -157.38024 297.41497 -325.9051 588.874 793.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(106.306 248.187 585.503) scale(610.055 288.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bu",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-118.299 459.449 91.058) scale(186.428 376.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bv",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-157.98712 -216.04394 291.40308 -213.09523 536.472 871.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bw",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-172.45609 -157.38024 297.41497 -325.9051 588.874 793.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__by",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(106.306 248.187 585.503) scale(610.055 288.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bC",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-118.299 459.449 91.058) scale(186.428 376.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-157.98712 -216.04394 291.40308 -213.09523 536.472 871.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bE",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-172.45609 -157.38024 297.41497 -325.9051 588.874 793.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bG",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(106.306 248.187 585.503) scale(610.055 288.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bK",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-118.299 459.449 91.058) scale(186.428 376.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bL",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-157.98712 -216.04394 291.40308 -213.09523 536.472 871.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bM",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-172.45609 -157.38024 297.41497 -325.9051 588.874 793.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bO",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(106.306 248.187 585.503) scale(610.055 288.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bS",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-118.299 459.449 91.058) scale(186.428 376.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bT",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-157.98712 -216.04394 291.40308 -213.09523 536.472 871.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bU",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-172.45609 -157.38024 297.41497 -325.9051 588.874 793.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__bW",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(106.306 248.187 585.503) scale(610.055 288.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6A577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#EAA66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8126",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__ca",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-118.299 459.449 91.058) scale(186.428 376.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2A6F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__cb",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-157.98712 -216.04394 291.40308 -213.09523 536.472 871.572)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCA08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA98D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "astaria-logo_svg__cc",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-172.45609 -157.38024 297.41497 -325.9051 588.874 793.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC968D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC9B8D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__b",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__c",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__d",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__h",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__j",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__k",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__l",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__p",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__r",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__s",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__t",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__x",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__z",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__A",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__B",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__F",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__H",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__I",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__J",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__N",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__P",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__Q",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__R",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__V",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__X",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__Y",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__Z",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__ad",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__af",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__ag",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__ah",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__al",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__an",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__ao",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__ap",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__at",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__av",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aw",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__ax",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aB",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aD",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aE",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aF",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aJ",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aL",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aM",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aN",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aR",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aT",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aU",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aV",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__aZ",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bb",
    x1: 2248.74,
    y1: 229.873,
    x2: 2310.69,
    y2: 509.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bc",
    x1: 3963.89,
    y1: 129.467,
    x2: 3919.02,
    y2: 473.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bd",
    x1: 1179.17,
    y1: 365.253,
    x2: 1236.29,
    y2: 684.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bh",
    x1: 312.004,
    y1: 270.487,
    x2: 381.686,
    y2: 530.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bj",
    x1: 667.477,
    y1: 229.648,
    x2: 811.633,
    y2: 349.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bk",
    x1: 982.28,
    y1: 129.241,
    x2: 816.941,
    y2: 362.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bl",
    x1: 471.165,
    y1: 365.027,
    x2: 635.864,
    y2: 533.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bp",
    x1: 312.004,
    y1: 270.262,
    x2: 441.922,
    y2: 359.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__br",
    x1: 667.477,
    y1: 229.648,
    x2: 811.633,
    y2: 349.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bs",
    x1: 982.28,
    y1: 129.241,
    x2: 816.941,
    y2: 362.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bt",
    x1: 471.165,
    y1: 365.027,
    x2: 635.864,
    y2: 533.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bx",
    x1: 312.004,
    y1: 270.262,
    x2: 441.922,
    y2: 359.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bz",
    x1: 667.477,
    y1: 229.648,
    x2: 811.633,
    y2: 349.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bA",
    x1: 982.28,
    y1: 129.241,
    x2: 816.941,
    y2: 362.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bB",
    x1: 471.165,
    y1: 365.027,
    x2: 635.864,
    y2: 533.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bF",
    x1: 312.004,
    y1: 270.262,
    x2: 441.922,
    y2: 359.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bH",
    x1: 667.477,
    y1: 229.648,
    x2: 811.633,
    y2: 349.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bI",
    x1: 982.28,
    y1: 129.241,
    x2: 816.941,
    y2: 362.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bJ",
    x1: 471.165,
    y1: 365.027,
    x2: 635.864,
    y2: 533.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bN",
    x1: 312.004,
    y1: 270.262,
    x2: 441.922,
    y2: 359.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bP",
    x1: 667.477,
    y1: 229.648,
    x2: 811.633,
    y2: 349.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bQ",
    x1: 982.28,
    y1: 129.241,
    x2: 816.941,
    y2: 362.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bR",
    x1: 471.165,
    y1: 365.027,
    x2: 635.864,
    y2: 533.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bV",
    x1: 312.004,
    y1: 270.262,
    x2: 441.922,
    y2: 359.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bX",
    x1: 667.477,
    y1: 229.648,
    x2: 811.633,
    y2: 349.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bY",
    x1: 982.28,
    y1: 129.241,
    x2: 816.941,
    y2: 362.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0A9F0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#C0A9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__bZ",
    x1: 471.165,
    y1: 365.027,
    x2: 635.864,
    y2: 533.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDF9E8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "astaria-logo_svg__cd",
    x1: 312.004,
    y1: 270.262,
    x2: 441.922,
    y2: 359.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF3D0",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAstariaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/astaria-logo.5f7e173e.svg";